import { createModel } from '@rematch/core';

import { RootModel } from '.';

// import { api } from '../utils/api';

interface State {
  [navItemName: string]: number;
}

const initialState: State = {};

export const navigationCounter = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setNavigationCounter(
      state,
      payload: {
        menuItem: string;
        number: number;
      },
    ) {
      return {
        ...state,
        [payload.menuItem]: payload.number,
      };
    },
  },
  effects: (dispatch) => ({
    async getAssignTopicsCounter(teamId: string) {
      try {
        // TODO: Disable while not being used
        // const { count } = await api.get<never, { count: number }>(
        //   `/v1/teams/${teamId}/videos/unassigned/count`
        // );
        dispatch.navigationCounter.setNavigationCounter({
          menuItem: 'assign-topics',
          number: 0,
        });
      } catch (err) {}
    },
  }),
});
